var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7E00E0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424,0H138c-36.4,0-66,29.6-66,66v374c0,39.7,32.3,72,72,72h280c8.8,0,16-7.2,16-16s-7.2-16-16-16H144 c-22.1,0-40-17.9-40-40s17.9-40,40-40h280c8.8,0,16-7.2,16-16V16C440,7.2,432.8,0,424,0z M104,371.4V66c0-18.8,15.2-34,34-34h1 c2.8,0,5,2.2,5,5v326.2c0,2.6-2,4.8-4.6,5c-10.1,0.6-19.6,3.4-28.2,7.8C107.9,377.6,104,375.1,104,371.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424,424H144c-8.8,0-16,7.2-16,16s7.2,16,16,16h280c8.8,0,16-7.2,16-16S432.8,424,424,424z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayBook);
export default __webpack_public_path__ + "static/media/DayBook.aa9fe8b6dc180139fdf591f1da125d10.svg";
export { ForwardRef as ReactComponent };